// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3m1PK","disabled":"FileBtn_disabled__3R78Y","warn":"FileBtn_warn__7S8Bs","fade":"FileBtn_fade__1mSsW"};